# Locations

SEEK’s location hierarchy has been extended with increased granularity in core Asia-Pacific locations.
If you have already built a supported [implementation option] in your software,
these changes have been automatically rolled out to your hirers and you can [skip to the next section].

Legacy integrations that use static location mappings must move to a supported option as part of this revision.
SEEK can no longer justify the effort of producing mapping files tailored to each partner and the administrative overhead of managing manual updates,
particularly as our ontologies have expanded in scope and are now evolving at a quicker pace.
For reference, our location hierarchy has been revised six times over the past six months.

1. If your software can interactively prompt the hirer to select a location from a SEEK-specific autosuggest field,
   build [location suggest] then provide the selected location ID to our posting mutations.

2. If your software has its own location hierarchy which contains latitudes and longitudes,
   build [nearest locations] then provide the first location ID to our posting mutations.

   SEEK will reliably infer a location based on the closest proximity to the supplied coordinates.

3. If your software has its own location hierarchy which lacks latitudes and longitudes,
   build [infer locations] then provide the location ID to our posting mutations.

   SEEK will attempt to match the supplied details to a location in our hierarchy on a best-effort basis.
   Location inference is less reliable than the other location options and should be used only as a last resort.

[infer locations]: /use-cases/job-posting/locations#option-3-use-location-inference
[implementation option]: /use-cases/job-posting/locations#implementation-options
[location suggest]: /use-cases/job-posting/locations#option-1-build-a-seek-specific-location-input
[nearest locations]: /use-cases/job-posting/locations#option-2-map-from-your-internal-location-hierarchy
[skip to the next section]: /migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/salary
